import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "./components/Nav";
import Hero from "./components/Hero";
import TheThree from "./components/TheThree";
import About from "./components/About";
import PastPortfolio from "./components/PastPortfolio";
import FutureIdeas from "./components/FutureIdeas";
import Writing from "./components/Writing";
import BookCall from "./components/BookCall";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Landing = () => {
  return (
    <div className="App" data-testid="landing-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main className="relative">
        <Hero />
        <TheThree />
        <About />
        <PastPortfolio />
        <FutureIdeas />
        <Writing />
        <BookCall />
        <Contact />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0c0a04",
            border: "1px solid #332D1D",
            color: "#FAFAFA",
            fontFamily: "'Outfit', sans-serif",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
